import { Component, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { GItem } from '@app/cp/shared/models/GItem';
import { TaxLinesBus } from '@app/cp/shared/models/TaxLinesBus';
import { TaxCodeBus } from '../../models/TaxCodeBus';
import { CustomerService } from '../../services/customer.service';
import { BaseAppEditComponent } from '../../base-components/base-app-edit.component';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { TaxLinesComponent } from './tax-lines/tax-lines.component';

@Component({
    selector: 'tax-code',
    templateUrl: './tax-code.component.html',
    styleUrls: ['./tax-code.component.scss'],
    standalone: false
})
export class TaxCodeComponent extends BaseAppEditComponent<TaxCodeBus, CustomerService>  {

    @ViewChild("LineItems") lineItemsComponent: TaxLinesComponent;
    constructor(globals: GlobalsService, qry_rd: DQOIReferenceDataQuery, svc_data: CustomerService) {
        super(globals, qry_rd);
        this.svc_data = svc_data;
        this.className = "TaxCodeBus";
        this.saveMode = SaveMode.all;
        this.appCode = "TaxCode";
        this.createForm();
        this.readOnly = false;
    }
    appCode: string = null;
    devOnly: boolean = false;
    taxLines: TaxLinesBus[];
    createForm() {
        this.editForm = new UntypedFormGroup({
            'taxCodeId': new UntypedFormControl(),
            'personId': new UntypedFormControl(),
            'companyId': new UntypedFormControl(),
            'isActive': new UntypedFormControl(),
            'isRetailTax': new UntypedFormControl(),
            'taxCode': new UntypedFormControl(),
            'taxDesc': new UntypedFormControl(),
            'taxRate': new UntypedFormControl()
        });

    }
    setForm() {
        this.editForm.patchValue({
            taxCodeId: this.selectedData.taxCodeId,
            personId: this.selectedData.personId,
            companyId: this.selectedData.companyId,
            isActive: this.selectedData.isActive,
            isRetailTax: this.selectedData.isRetailTax,
            taxCode: this.selectedData.taxCode,
            taxDesc: this.selectedData.taxDesc,
            taxRate: this.selectedData.taxRate
        });
    }
    taxCodeCBOChanged(item: GItem) {
        if (item) {
            this.svc_data.getTaxCode(item.value, false).subscribe((data: TaxCodeBus) => {
                if (data) {
                     this.setup(data);
                }
                else {
                    this.clear();
                    //this.data.setTaxCode(null);
                }
            });
        }
        else {
            this.clear();
        }

    }
    public setup(data: any) {
        if (CommonFunctions.hasValue(data)) {
            this.setData(data);
        }
        else {

        }
        if (this.devOnly && !CommonFunctions.hasArrayElementValue(this.taxLines)) {
            this.svc_data.getTaxLines(false).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let arr = [];
                    let tmpI = 0;
                    for (let item of info.primaryReturn) {
                        let busObj: TaxLinesBus = new TaxLinesBus(item);
                        arr.push(busObj);
                       // tmpI++;
                    //    if (tmpI > 100) {
                    //        break;
                    //    }
                    }
                    info = null;
                    this.taxLines = arr;
                }
            });
        }
    }

    cancelEvent() {
        this.close(false);
    }
    saveEvent() {
        this.close(true);
    }
    close(e: any) {
        super.close(e);
    }
    taxLinesEdit() {
        this.taxLinesActive = true;
    }
    taxLinesDone(e: any) {
        this.taxLinesActive = false;
    }
    taxLinesActive: boolean = false;
}
